
/**
 * Type of tweet
 */
export type TweetFeedResponseTweetsItemTweetType = typeof TweetFeedResponseTweetsItemTweetType[keyof typeof TweetFeedResponseTweetsItemTweetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TweetFeedResponseTweetsItemTweetType = {
  ORIGINAL: 'ORIGINAL',
  REPLY: 'REPLY',
  QUOTE: 'QUOTE',
} as const;
